import {
  Award,
  BookOpen,
  ClipboardCheck,
  GraduationCap,
  Globe,
  Languages,
  Layers,
  LayoutGrid,
  type LucideIcon,
} from 'lucide-react';
import { normalizeCategorySlug } from 'modules/test/public-categories';

/** One category's identity on the tests hub and its own page: a single accent and a watermark icon. */
export interface CategoryTheme {
  accent: string;
  icon: LucideIcon;
}

const THEMES: Record<string, CategoryTheme> = {
  ielts: { accent: '#B42318', icon: Globe },
  sat: { accent: '#1D4ED8', icon: BookOpen },
  dtm: { accent: '#C2410C', icon: GraduationCap },
  attestation: { accent: '#166534', icon: ClipboardCheck },
  'milliy-sertifikat': { accent: '#0B4F5C', icon: Award },
  general: { accent: '#6D28D9', icon: Layers },
  languages: { accent: '#92400E', icon: Languages },
};

const FALLBACK_THEME: CategoryTheme = { accent: '#475569', icon: LayoutGrid };

/** A category the API adds later has no theme yet and gets a neutral slate one. */
export function categoryTheme(categoryId: string): CategoryTheme {
  return THEMES[normalizeCategorySlug(categoryId)] ?? FALLBACK_THEME;
}

/**
 * The accent mixed into the card colour keeps tint, border and ink readable on the light and the dark
 * surface alike, which fixed hex tints would not.
 */
export function categorySurface(accent: string) {
  return {
    background: `color-mix(in srgb, ${accent} 11%, hsl(var(--card)))`,
    borderColor: `color-mix(in srgb, ${accent} 24%, hsl(var(--border)))`,
    color: `color-mix(in srgb, ${accent} 72%, hsl(var(--foreground)))`,
  };
}
